export const WITHDRAWAL_CONFIGURATION_VALIDATION_RULES = {};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/withdrawalConfigurationValidationRules.js